import { createSlice } from "@reduxjs/toolkit";
import { getBookingIdAPI} from "../../api/customer";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const getBookingIdSlice = createSlice({
  name: "getBookingId",
  initialState: data,
  reducers: {
   getBookingIdSlice(state) {
      state.isLoading = true;
    },
   getBookingIdSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getBookingIdSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   getBookingIdSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const getBookingIdHandler = (search:any,page:any,limit:any,sort_by:any,sort_direction:any,start_date:any,end_date:any,selectedStatus:any,id:any) => async (dispatch: any) => {
  try {
    dispatch(getBookingIdAction.getBookingIdSlice());
    const response: any = await getBookingIdAPI(search,page,limit,sort_by, sort_direction , start_date,end_date,selectedStatus,id);
    
    dispatch(getBookingIdAction.getBookingIdSliceSuccess(response));
  } catch (e: any) {
    dispatch(getBookingIdAction.getBookingIdSliceFailure(e?.response?.data));
  }
};
export default getBookingIdSlice.reducer;
export const getBookingIdAction = getBookingIdSlice.actions;
